//@ts-nocheck
import {useEffect, useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {usersColumns} from './columns/_columns'
import {User} from '../core/_models'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {gql, useQuery} from '@apollo/client'
import useFetchAdmins from '../../../../../hooks/useFetchAdmins'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import axios from 'axios'
import {BASE_URL} from '../../../../../../api'

const UsersTable = ({userSearch, setUserSearch, page, setPage, sDate, eDate}) => {
  // const {admins, pagination, error, loading, refetchAdmins} = useFetchAdmins(
  //   page,
  //   sDate,
  //   eDate,
  //   userSearch
  // )
  const [userData, setUserData] = useState([]) // Store user data
  const [paginationDetails, setPaginationDetails] = useState({})
  const [loading, setLoading] = useState<boolean>(true) // Add loading state

  useEffect(() => {
    // Fetch user data and pagination details when page or other filters change
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/admin/sub-admin`, {
          params: {page, query: userSearch, startDate: sDate, endDate: eDate},
        })

        console.log(response.data,'response here')
        const {docs, ...pagination} = response.data
       setUserData(docs)
        setPaginationDetails(pagination)
        setLoading(false) // Set loading to false once data is fetched
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false) // Set loading to false on error
      }
    }

    fetchData()
  }, [userSearch, page, sDate, eDate])

  const data = useMemo(() => userData, [userData])
  const columns = useMemo(() => usersColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<User>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <UsersListPagination
        page={page}
        setPage={setPage}
        totalPages={
          page + 5 < paginationDetails.totalPages ? page + 5 : paginationDetails.totalPages
        }
        loading={loading}
        paginationDetails={paginationDetails}
      />
      {loading && <UsersListLoading />}
      {loading && <UsersListLoading />}
    </KTCardBody>
  )
}

export {UsersTable}
